// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.USV5OdNGtq673JIdiI45 input[type="file"] {
    display: flex;
    align-items: center;
    width: 100%;
}
`, "",{"version":3,"sources":["webpack://./src/pages/dashboard/admin/import/interest_imports/components/upload.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf","sourcesContent":[".label input[type=\"file\"] {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"label": `USV5OdNGtq673JIdiI45`
};
export default ___CSS_LOADER_EXPORT___;
